import { Box, Divider, FormHelperText, Grid, LinearProgress } from "@mui/material";
import React, { useEffect } from "react";
import Label from "../../../components/Common/Label";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomButton from "../../../components/Form/CustomButton";
import { verify_admin } from "../../../store/actions";
import { useDispatch } from "react-redux";

export default function PlanInfo({ formObj, handleFormChange, isDirectSeller, planList, userData, error }) {
    const dispatch = useDispatch()
    const directSellerPlan = [
        {
            id: 1,
            name: 'Starter Plan',
            is_popular: false,
            price: 'FREE',
            duration: '90 days',
            visibility: 'Standard',
            features: ['Appears in search results', 'Visible under “Latest Listings”']
        },
        {
            id: 2,
            name: 'Premium Plan',
            comingSoon: true,
            price: 50,
            duration: '180 days',
            visibility: 'High',
            features: ['Priority placement above Basic Ads', 'Shown in “Featured Listings”', 'Allow to boost 5 times.']
        },
    ]

    useEffect(() => {
        dispatch(verify_admin());
    }, [])

    return (
        <React.Fragment>
            {/* {vehiclvevvvvv
                !isDirectSeller &&
                <div className="mt-3 dashboard-card">
                    <Grid container spacing={2}>
                        <Grid item md={12} className="d-flex align-items-center text-semibold font-size-18">
                            Standard Plan
                            <Label.CustomLabel
                                label={'Current Plan'}
                                color={'#808588'}
                                backgroundColor={'#F5F5F5'}
                                border={"1px solid #F5F5F5"}
                                borderRadius={6}
                                marginLeft={10}
                            />
                        </Grid>
                    </Grid>
                    <div className="d-flex justify-content-between mb-2 mt-4">
                        <div className="d-flex align-items-center text-semibold">Credit Usage </div>
                        <div className="subheader-2"><span style={{ fontWeight: 600, color: '#031634' }}>{5}</span> / {250} credits</div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div style={{ width: '100%', color: '#D13536', backgroundColor: '#E9ECF3' }}>
                            <LinearProgress variant="determinate" color="inherit" value={80} />
                        </div>
                    </div>
                    <div className="subheader-2 mt-2">Total credits: {20} credits per month</div>
                </div>
            } */}
            <Box className="my-3 subheader-2" sx={{ justifyContent: { lg: 'space-between', md: 'space-between' }, display: { lg: 'flex', md: 'flex' } }}>
                {isDirectSeller ? 'Choose a one-time plan to post your advert.' : 'Select your advert plan and visibility level.'}
                <div>Credit Balance: <span style={{ color: '#101010' }}>{userData?.profile?.credit_balance || 0} credits</span></div>
            </Box>
            {
                error &&
                <FormHelperText className='d-flex align-items-center m-0 mt-1 mb-2' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error || ""}</FormHelperText>
            }
            <Grid container spacing={2}>
                {
                    planList.map((plan, index) => (
                        <Grid item lg={isDirectSeller ? 4.5 : 4} md={6} sm={12} xs={12} key={`plan-${index}`}>
                            <div className={`${formObj?.bike_advert_plan_id === plan.id ? 'dashboard-selected-card' : 'dashboard-card'} p-3`} style={{ minHeight: isDirectSeller ? 430 : 350, position: 'relative' }}>
                                <Grid container spacing={1} style={{ flexGrow: 1 }}>
                                    <Grid item sm={12} className="font-size-16 mb-2">
                                        <div className="text-semibold d-flex align-items-center">
                                            {plan?.title || '-'}
                                            {
                                                plan?.is_popular === 1 &&
                                                <Label.CustomLabel
                                                    label={'Popular'}
                                                    color={'#D13536'}
                                                    backgroundColor={'#FFE9E9'}
                                                    border={"1px solid #FFE9E9"}
                                                    borderRadius={6}
                                                    marginLeft={10}
                                                />
                                            }
                                        </div>
                                        {isDirectSeller ? <div className="text-semibold" style={{ color: '#D13536' }}>{isDirectSeller ? "" : plan?.price !== 'FREE' && '$'}{plan?.price || isDirectSeller ? plan?.is_active == 1 ? "Free" : "Coming Soon" : '-'}</div>
                                            : <div className="text-semibold" style={{ color: '#D13536' }}>{plan?.credit_amount || '-'} Credits</div>}
                                    </Grid>
                                    <Grid item sm={6} className="subheader-2">Duration</Grid>
                                    <Grid item sm={6} sx={{ display: 'flex', justifyContent: { lg: 'flex-end', md: 'flex-end' } }}>
                                        {plan?.duration_in_days || '-'}
                                    </Grid>
                                    <Grid item sm={6} className="subheader-2">Visibility</Grid>
                                    <Grid item sm={6} sx={{ display: 'flex', justifyContent: { lg: 'flex-end', md: 'flex-end' } }}>
                                        {plan?.visibility === 1 ? 'Standard' : plan?.visibility === 2 ? 'High' : '-'}
                                    </Grid>
                                    <Grid item sm={12} my={1}><Divider /></Grid>
                                    <Grid item sm={12}>
                                        <div dangerouslySetInnerHTML={{ __html: plan?.description || '-' }}></div>
                                        {
                                            plan?.features?.map((feature, idx) => (
                                                <div className="d-flex align-items-start mb-2">
                                                    <Icon icon={'fluent:checkmark-circle-24-filled'} style={{ color: '#34C759', height: 20, width: 20 }} />
                                                    <div className="ms-2">{feature || '-'}</div>
                                                </div>
                                            ))
                                        }
                                    </Grid>
                                    {
                                        plan?.comingSoon &&
                                        <Grid item sm={12}>
                                            <div className="d-flex p-3" style={{ backgroundColor: '#FAEAB1', borderRadius: 8 }}>
                                                <div>
                                                    <Icon icon={'fluent:warning-24-regular'} style={{ width: 16, marginRight: 10 }} />
                                                </div>
                                                <div>This feature is coming soon! Stay tuned for updates.</div>
                                            </div>
                                        </Grid>
                                    }
                                </Grid>
                                <div className=" justify-content-center mt-3" style={{ position: 'absolute', bottom: 20, left: 24, right: 24 }}>
                                    {
                                        plan?.is_active === 0 ?
                                            <CustomButton
                                                title={'Coming Soon'}
                                                backgroundColor={'#F5F5F5'}
                                                borderStyle={'1px solid #F5F5F5'}
                                                textColor={'#1D1B1B'}
                                                disabled={true}
                                                press={() => { }}
                                                width={'100%'}
                                                padding={20}
                                            /> :
                                            <CustomButton
                                                title={formObj?.bike_advert_plan_id === plan.id ? 'Selected' : 'Select Plan'}
                                                backgroundColor={formObj?.bike_advert_plan_id === plan.id ? '#1D1B1B' : '#F5F5F5'}
                                                borderStyle={`1px solid ${formObj?.bike_advert_plan_id === plan.id ? '#1D1B1B' : '#F5F5F5'}`}
                                                textColor={formObj?.bike_advert_plan_id === plan.id ? '#FFFFFF' : '#1D1B1B'}
                                                press={() => handleFormChange('bike_advert_plan_id', formObj?.bike_advert_plan_id === plan.id ? null : plan.id)}
                                                width={'100%'}
                                                padding={20}
                                            />
                                    }
                                </div>
                            </div>
                        </Grid>
                    ))
                }
            </Grid>
            {!isDirectSeller && <div className="mt-3 subheader-2">*Credits will be deducted immediately upon publishing.</div>}
        </React.Fragment>
    )
}